export const name = '@lifi/sdk';
export const version = '2.0.0-beta.11';
